// eslint-disable-next-line no-unused-vars
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { node, object } from 'prop-types';
import { I18nextProvider } from 'react-i18next';

import ThemeProvider from 'Providers/theme/ThemeProvider';
import { createCache } from 'Providers/swr/swr';
import SWRConfig from 'Providers/swr/config';
import i18n from 'Providers/i18n/TranslationProvider';

import UIProvider from 'Contexts/UIContext';
import UserProvider from 'Contexts/UserContext';
import CartProvider from 'Contexts/CartContext';
import CategoriesProvider from 'Contexts/CategoriesContext';
import FetchProvider from 'Contexts/FetchContext';
import WishlistProvider from 'Contexts/WishlistContext';
import OffersProvider from 'Contexts/OffersContext';
import ModalsProvider from 'Contexts/ModalsContext';
import NotificationsProvider from 'Contexts/UserNotificationsContext';
import ToastNotificationsProvider from 'Contexts/ToastNotificationsContext';
import AccountProvider from 'Contexts/AccountContext';
import AnalyticsProvider from 'Contexts/AnalyticsContext';

import ErrorBoundary from 'Containers/ErrorBoundary/ErrorBoundary';
import LoginModalWrapper from 'Containers/Login/LoginModalWrapper';

import InitialPagePropsType from 'Types/initialPageProps';
import BreadcrumbsProvider from 'Contexts/BreadcrumbsContext';
import { DEFAULT_LANG } from 'Constants';
import { ResetScroll, CaseInsensitiveRedirect } from 'Components/shared';

export default function AppProvidersWrapper({ initialProps, context, children }) {
  const { user, categories } = initialProps;
  createCache(
    new Map(Object.entries(initialProps).concat([['serverSide', !!context?.serverSide]]))
  );

  return (
    <I18nextProvider i18n={ i18n(initialProps?.user?.language || DEFAULT_LANG) }>
      <BrowserRouter basename={ context ? context.base : '/' }>
        <ResetScroll />
        <CaseInsensitiveRedirect />
        <FetchProvider>
          <SWRConfig>
            <BreadcrumbsProvider>
              <ErrorBoundary>
                <UserProvider user={ user }>
                  <UIProvider>
                    <ThemeProvider>
                      <CartProvider>
                        <WishlistProvider>
                          <OffersProvider>
                            <CategoriesProvider categories={ categories }>
                              <AccountProvider>
                                <ModalsProvider>
                                  <NotificationsProvider>
                                    <ToastNotificationsProvider>
                                      <LoginModalWrapper>
                                        <AnalyticsProvider>
                                          { children }
                                        </AnalyticsProvider>
                                      </LoginModalWrapper>
                                    </ToastNotificationsProvider>
                                  </NotificationsProvider>
                                </ModalsProvider>
                              </AccountProvider>
                            </CategoriesProvider>
                          </OffersProvider>
                        </WishlistProvider>
                      </CartProvider>
                    </ThemeProvider>
                  </UIProvider>
                </UserProvider>
              </ErrorBoundary>
            </BreadcrumbsProvider>
          </SWRConfig>
        </FetchProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

AppProvidersWrapper.propTypes = {
  children: node,
  initialProps: InitialPagePropsType,
  context: object
};
